import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ticker-card',
  templateUrl: './ticker-card.component.html',
  styleUrls: ['./ticker-card.component.scss'],
  standalone: true,
})
export class TickerCardComponent {
  @Input() titleText = '';

  @Input() descriptionText = '';

  @Input() data: any | null = null;

  @Input() total: string | null = null;

  @Input() percentage = 0;

  @Input() icon = '';

  @Input() tone?: 'warning' | 'info';

  @Input() contentClass: string | null = null;

  abs(value: number): number {
    return Math.abs(value);
  }

  getIconClass = () =>
    this.tone || (this.percentage > 0 ? 'positive' : 'negative');
}
